import { useCallback, useEffect, useState } from 'react';
import { dispatcher } from 'dispatcher';

import { VALIDATION_EVENTS } from '@interlayer/js/app/hooks/useValidationRules/constants';

export const useCheckPin = (isBlocked?: boolean) => {
    const [errorsPin, setErrorsPin] = useState<Record<string, string>>({});

    useEffect(() => {
        if (isBlocked) {
            return;
        }

        dispatcher.listen(VALIDATION_EVENTS.SET_PIN_ERROR, setErrorsPin);

        return () => {
            dispatcher.removeListener(VALIDATION_EVENTS.SET_PIN_ERROR, setErrorsPin);
        };
    }, [isBlocked]);

    return useCallback((value: string) => {
        if (Object.prototype.hasOwnProperty.call(errorsPin, value)) {
            return [errorsPin[value]];
        }
    }, [errorsPin]);
};

